import { inject, Injectable, signal } from '@angular/core';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { ZONA_HORARIA_DEFAULT } from '../../constants/zona-horaria.constants';
import { EmpresaService } from '../empresa/empresa.service';
import { AuthService } from '../auth/auth.service';
import { hoyCalendarioEnEmpresa } from '../../utils/empresa-timezone.util';

@Injectable({ providedIn: 'root' })
export class ZonaHorariaEmpresaService {
  private readonly _empresaService = inject(EmpresaService);
  private readonly _authService = inject(AuthService);
  private readonly _zona = signal(ZONA_HORARIA_DEFAULT);
  private _loaded = false;

  readonly zona = this._zona.asReadonly();

  zonaActual(): string {
    return this._zona();
  }

  actualizar(zona?: string | null): void {
    const t = zona?.trim();
    if (t) {
      this._zona.set(t);
    }
  }

  hoyCalendario(): string {
    return hoyCalendarioEnEmpresa(this._zona());
  }

  ensureLoaded(): Observable<string> {
    if (this._loaded) {
      return of(this._zona());
    }
    if (!this._authService.isAuthenticated()) {
      return of(this._zona());
    }
    return this._empresaService.obtenerDatos().pipe(
      tap((empresa) => {
        this._loaded = true;
        this.actualizar(empresa?.zona_horaria);
      }),
      map(() => this._zona()),
      catchError(() => {
        this._loaded = true;
        return of(this._zona());
      }),
    );
  }
}
